import React from 'react';
import { Caption, Theme } from '@routific/hive';

interface Props {
  text: string;
}

const TooltipCaption: React.FC<Props> = ({ text }) => {
  const style = {
    color: Theme.Colors.gray0,
  };
  return (
    <Caption style={style}>{text}</Caption>
  );
};

export default TooltipCaption;
